import {removeMaterialNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialKeys, materialMutationKeys} from "../../../../../material-keys";

export function removeMaterialNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: materialMutationKeys.removeMaterialNote,
    mutationFn: (noteId: number) => removeMaterialNote(id, noteId),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialKeys.detail(id)}),
        client.invalidateQueries({queryKey: materialKeys.lists()}),
      ]);
    },
  });
}
